import { escapeSingleQuotes } from "../odata-string-utils.ts";
import type { TokenType } from "../odata-types.ts";
import { Expression } from "./base/Expression.ts";
import type { PropertyInfo } from "./base/types.ts";
import type { PropertyExpression } from "./PropertyExpression.ts";

export class FunctionExpression extends Expression {
    readonly type = "function";
    public name: typeof TokenType.CONTAINS | typeof TokenType.STARTSWITH | typeof TokenType.ENDSWITH;
    public property: PropertyExpression;
    public searchTerm: string;

    constructor(
        name: typeof TokenType.CONTAINS | typeof TokenType.STARTSWITH | typeof TokenType.ENDSWITH,
        property: PropertyExpression,
        searchTerm: string
    ) {
        super();
        this.name = name;
        this.property = property;
        this.searchTerm = searchTerm;
    }

    stringify(): string {
        const propertyStr = this.property.stringify();
        const searchTermStr = `'${escapeSingleQuotes(this.searchTerm)}'`;
        return `${this.name}(${propertyStr}, ${searchTermStr})`;
    }

    getKey(): string {
        return `${this.name}::${this.property.toPathString()}::${this.searchTerm}`;
    }

    getPropertyInfo(): PropertyInfo {
        return this.property.getPropertyInfo();
    }
}
